import { Tabs } from "flowbite-react";
import { FaAddressCard, FaCircleUser } from "react-icons/fa6";
import { MdPayments } from "react-icons/md";
import { FaArrowLeft, FaHome } from "react-icons/fa";
import { renterTheme } from "@/modules/renters/components/renter-dashboard/TabsStyle";
import { EmpresaDetailsBlock } from "./CompanyDetailsBlock";
import ContractsTableB2B from "../tables/ContractsTableB2B";
import VehiclesTableB2B from "../tables/VehiclesTableB2B";
import TableRenterB2B from "../tables/TableRenterB2B";
import { useNavigate } from "react-router-dom";
import { PaymentsB2B } from "../tables/PaymentsB2B";

export function CompanyDetailsTab() {
  const navigate = useNavigate();
  const handleGoBack = () => {
    navigate("/locacoesB2B");
  };
  return (
    <div className="relative flex justify-center w-full h-full overflow-y-auto bg-white dark:bg-white dark:text-black">
      <section className="max-w-7xl w-full p-2">
        <div className="mb-4 flex items-center">
          <button
            onClick={handleGoBack}
            className="flex items-center text-gray-700 hover:text-blue-600 font-medium p-2 rounded-lg transition duration-150 ease-in-out"
            aria-label="Voltar para Empresas B2B"
          >
            <FaArrowLeft className="mr-2 h-4 w-4" />
            Voltar para Empresas B2B
          </button>
        </div>
        <Tabs
          className="tabs-style-grid"
          theme={renterTheme}
          aria-label="Default tabs"
        >
          <Tabs.Item
            icon={FaCircleUser}
            title={<div className="tabs-name-style">Empresa</div>}
            className="bg-white"
          >
            <EmpresaDetailsBlock />
          </Tabs.Item>

          <Tabs.Item
            icon={MdPayments}
            title={<div className="tabs-name-style">Contratos</div>}
            className="bg-white"
            style={{ backgroundColor: "white" }}
          >
            <ContractsTableB2B />
          </Tabs.Item>

          <Tabs.Item
            icon={FaAddressCard}
            title={<div className="tabs-name-style">Veiculos</div>}
            className="bg-white"
          >
            <VehiclesTableB2B />
          </Tabs.Item>

          <Tabs.Item
            icon={FaHome}
            title={<div className="tabs-name-style">Ativos</div>}
            className="bg-white"
          >
            <TableRenterB2B />
          </Tabs.Item>

          <Tabs.Item
            icon={MdPayments}
            title={
              <div className="tabs-name-style">
                Pagamentos
              </div>
            }
          >
            <PaymentsB2B />
          </Tabs.Item>
        </Tabs>
      </section>
    </div>
  );
}
